import Modal from '../Modal';
import { truncate } from '../../lib/Utils.js';
import { useEffect, useState } from 'react';
import { calendarToAccount, TypeToIcon } from '../../lib/CalendarSyncing.jsx';
import SectionHeading from '../SectionHeading.jsx';

function isSupportedAccount(account) {
    return account.type === 'google' || account.type === 'icloud' || account.type === 'office365';
}

const AddEventsToCalendarModal = ({
    isOpen,
    onClose,
    onSave,
    value,
    setValue,
    accountOptions,
}) => {
    const [selectedAccount, setSelectedAccount] = useState();
    const [originalValue, setOriginalValue] = useState(value);
    const [isSaving, setIsSaving] = useState(false);
    const [isCalendarError, setIsCalendarError] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setOriginalValue(value);
            setIsSaving(false);
            setIsCalendarError(false);
            setSelectedAccount(
                value ? calendarToAccount(value, accountOptions) : '',
            );
        }
    }, [isOpen]);

    const selectedAccountOptions = accountOptions.filter(
        a => a.id === selectedAccount,
    )[0]?.options || [];

    return (
        <Modal
            isOpen={isOpen}
            onClose={() => {
                // This was a cancel...
                if (value !== originalValue || (selectedAccount && !value)) {
                    if (
                        !confirm(
                            'You have unsaved changes, do you want to discard them?',
                        )
                    ) {
                        return;
                    }
                    setValue(originalValue);
                }

                onClose();
            }}
        >
            <h2 className="mb-6">Add New Events</h2>
            <div className="input-label">Account</div>
            <div>
                {accountOptions.map(account => (
                    <SectionHeading className="mb-2">
                        <label className="flex justify-between items-center">
                            <div
                                className={`flex items-center ${!isSupportedAccount(account) ? 'text-gray-500' : ''}`}
                            >
                                <input
                                    type="radio"
                                    name="add-to-radio"
                                    className="mr-3"
                                    disabled={!isSupportedAccount(account)}
                                    checked={
                                        parseInt(account.id) ===
                                        parseInt(selectedAccount)
                                    }
                                    onChange={ev => {
                                        if (ev.target.checked) {
                                            setSelectedAccount(account.id);
                                            setValue('');
                                        }
                                    }}
                                />
                                <div>
                                    {account.name}
                                    {!isSupportedAccount(account) && (
                                        <div className="text-sm">(unable to add events to this account, provider is not supported)</div>
                                    )}
                                </div>
                            </div>
                            {TypeToIcon[account.type]}
                        </label>
                    </SectionHeading>
                ))}

                <label className="p-4 rounded-lg mb-2 block">
                    <input
                        type="radio"
                        name="add-to-radio"
                        className="mr-3"
                        checked={!parseInt(selectedAccount)}
                        onChange={ev => {
                            if (ev.target.checked) {
                                setValue('');
                                setSelectedAccount('');
                            }
                        }}
                    />
                    Do not add events to a calendar
                </label>
            </div>
            {!!selectedAccount && (
                <div
                    className={`border-t -mx-4 px-4 pt-4 ${isCalendarError && !value ? 'is-error' : ''}`}
                >
                    <div className="input-label">Add events to calendar</div>
                    <select
                        className="w-full"
                        value={value}
                        onChange={e => setValue(e.target.value)}
                    >
                        <option value="">Select a calendar...</option>
                        {Object.keys(selectedAccountOptions).map(id => (
                            <option
                                value={id}
                                disabled={
                                    !selectedAccountOptions[id].is_writeable
                                }
                            >
                                {truncate(selectedAccountOptions[id].name, 40)}
                                {!selectedAccountOptions[id].is_writeable &&
                                    ' (read only)'}
                            </option>
                        ))}
                    </select>
                    {isCalendarError && (
                        <div className="text-sm text-red-500 mt-1">
                            Please choose which calendar to add to
                        </div>
                    )}
                </div>
            )}

            <div className="mt-4 pt-4 border-t -mx-4 px-4">
                <button
                    className="btn-save"
                    type="button"
                    onClick={async () => {
                        if (selectedAccount && !value) {
                            setIsCalendarError(true);
                            return;
                        }
                        setIsCalendarError(false);
                        setIsSaving(true);
                        await onSave();
                        onClose();
                    }}
                >
                    {isSaving ? 'Saving...' : 'Save'}
                </button>
            </div>
        </Modal>
    );
};

export default AddEventsToCalendarModal;
